import { Partial } from '@40seas/entities/common';
import { ShippingStatus } from '@40seas/entities/shipping';
import { CreateShippingDto } from './create.shipping.dto';

export class UpdateShippingDto extends Partial(CreateShippingDto) {
    status: ShippingStatus;
}
